import React from 'react';
import style from './style.module.scss';
import { joinNames } from '../helpers';
import { CheckmarkIcon, InformationIcon, QuestionIcon } from '@n2-common/myPagesUi/components/icons';

export type Notification = { title: string };

export function isNotification(maybeNotification: unknown): maybeNotification is Notification {
    if (typeof maybeNotification == 'object' && maybeNotification != null) {
        return !!maybeNotification['title' as keyof typeof maybeNotification];
    }
    return false;
}

function maybeTitle(prop: boolean | Notification): string | undefined {
    return typeof prop == 'object' ? prop.title : undefined;
}

type NotificationIconProps = React.PropsWithChildren<{
    check?: boolean | Notification;
    alert?: boolean | Notification;
    question?: boolean | Notification;
    prefixForUiTesting?: string;
    /** If true a placeholder will be rendered , when now icons. Defaults to false */
    occupySpace?: boolean;
}> &
    React.HTMLAttributes<HTMLDivElement>;

export const NotificationIcon: React.FC<NotificationIconProps> = ({
    check,
    alert,
    question,
    className,
    prefixForUiTesting,
    occupySpace: placeholder,
    ...attr
}) => {
    return check || question || alert || placeholder ? (
        <div
            data-nameforuitesting={prefixForUiTesting && `${prefixForUiTesting}_notificationIcon`}
            className={joinNames(className, style.root)}
            {...attr}
        >
            {check && (
                <CheckmarkIcon className={style.checkMark}
                    data-nameforuitesting={prefixForUiTesting && `${prefixForUiTesting}_notificationIcon_valid`}
                    title={maybeTitle(check)}
                />
            )}
            {alert && (
                <InformationIcon secondaryColor={'var(--color-pink-200)'} className={style.alertMark} data-nameforuitesting={prefixForUiTesting && `${prefixForUiTesting}_notificationIcon_invalid`} title={maybeTitle(alert)} />
            )}
            {question && (
                <QuestionIcon  className={style.questionMark}
                    data-nameforuitesting={prefixForUiTesting && `${prefixForUiTesting}_notificationIcon_question`}
                    title={maybeTitle(question)}
                />
            )}
            {placeholder && !(check || alert || question) && <div style={{ width: '18px', height: '18px' }}></div>}
        </div>
    ) : null;
};

export default NotificationIcon;
